<template>
  <!-- Crop an image to a square before it's uploaded: client logos and profile photos (US 9391) -->
  <b-modal ref="dialog"
           size="lg"
           modal-class="v2-modal"
           hide-footer
           @shown="initCropper"
           @hidden="destroyCropper">
    <template #modal-header>
      <div class="us-modal-head">
        <div>
          <h5 class="mb-0">{{ title }}</h5>
          <p class="us-modal-head__sub">{{ $t('client_page.crop.subtitle') }}</p>
        </div>
        <button type="button" class="us-icon-btn" :aria-label="$t('profile_page.edit.cancel')" @click="close">
          <font-awesome-icon icon="times"/>
        </button>
      </div>
    </template>
    <div class="cp-crop" :class="{ 'cp-crop--round': round }">
      <img ref="image" :src="imageUrl" alt="" class="cp-crop__image">
    </div>
    <div class="cp-crop__tools">
      <button type="button" class="us-icon-btn" :aria-label="$t('client_page.crop.zoom_out')" :title="$t('client_page.crop.zoom_out')" @click="cropper && cropper.zoom(-0.1)">
        <font-awesome-icon icon="magnifying-glass-minus"/>
      </button>
      <button type="button" class="us-icon-btn" :aria-label="$t('client_page.crop.zoom_in')" :title="$t('client_page.crop.zoom_in')" @click="cropper && cropper.zoom(0.1)">
        <font-awesome-icon icon="magnifying-glass-plus"/>
      </button>
      <button type="button" class="us-icon-btn" :aria-label="$t('client_page.crop.reset')" :title="$t('client_page.crop.reset')" @click="cropper && cropper.reset()">
        <font-awesome-icon icon="rotate-left"/>
      </button>
      <span class="us-grow"></span>
      <span class="pf-hint">{{ hint }}</span>
    </div>
    <div class="us-modal-foot">
      <span class="us-grow"></span>
      <b-button variant="secondary" qid="crop-cancel-button" @click="close">{{ $t('profile_page.edit.cancel') }}</b-button>
      <b-button variant="success" :disabled="saving || !cropper" qid="crop-save-button" @click="crop">
        <font-awesome-icon v-if="saving" icon="spinner" class="fa-spin mr-1"/>
        {{ saveLabel }}
      </b-button>
    </div>
  </b-modal>
</template>

<script>
  import Cropper from 'cropperjs';
  import 'cropperjs/dist/cropper.css';

  // Size of the saved square, large enough for the biggest place the image is shown
  const SIZE = 512;

  export default {
    name: 'ImageCropDialog',
    props: {
      title: String,
      hint: String,
      saveLabel: String,
      // Profile photos are shown as circles, so the frame is round
      round: Boolean,
      saving: Boolean
    },
    data() {
      return {
        imageUrl: '',
        cropper: null
      }
    },
    methods: {
      open(file) {
        this.imageUrl = URL.createObjectURL(file);
        this.$refs.dialog.show();
      },
      close() {
        this.$refs.dialog.hide();
      },
      initCropper() {
        this.cropper = new Cropper(this.$refs.image, {
          aspectRatio: 1,
          viewMode: 1,
          autoCropArea: 1,
          background: false
        });
      },
      destroyCropper() {
        if (this.cropper) {
          this.cropper.destroy();
          this.cropper = null;
        }
        if (this.imageUrl) {
          URL.revokeObjectURL(this.imageUrl);
          this.imageUrl = '';
        }
      },
      // Hands the cropped square to the parent as a PNG file; the parent saves it and closes the dialog
      crop() {
        this.cropper.getCroppedCanvas({ width: SIZE, height: SIZE, fillColor: '#fff' }).toBlob(blob => {
          this.$emit('crop', new File([blob], 'image.png', { type: 'image/png' }));
        }, 'image/png');
      }
    }
  }
</script>
